import React from "react";
import { View, Text, StyleSheet, Modal, Pressable } from "react-native";
import * as Animatable from "react-native-animatable";
import metrics from "@constants/metrics";
import SuspendedIcon from "@assets/svg/SuspendedIcon";
import CloseIcon from "@assets/svg/CloseIcon";
import Button from "@components/Button";
import { useDispatch } from "react-redux";
import { actions as authActions } from "@reducers/authReducer";
import SuspensionHOC from "@components/SuspensionHOC";

import t from "../constants/localization";
import { fontFamily } from "@utils/styles";

const PATH = "components/SuspensionModal";

function SuspensionModal(props) {
  const dispatch = useDispatch();
  const {
    is_suspended,
    showSuspensionModal,
    onClickRaiseSupportTicket,
    fetchMeCompleted,
  } = props;

  if (fetchMeCompleted && is_suspended && showSuspensionModal) {
    return (
      <Modal
        animationType="fade"
        transparent={true}
        style={{}}
        visible={showSuspensionModal}
        statusBarTranslucent
      >
        <Animatable.View
          duration={300}
          useNativeDriver={true}
          delay={0}
          animation="slideInUp"
          style={styles.centeredView}
        >
          <View style={styles.modalView}>
            <View style={{ marginTop: 20, flexDirection: "column" }}>
              <View style={{ alignItems: "flex-end" }}>
                <Pressable
                  onPress={() =>
                    dispatch(authActions.showSuspensionModal(false))
                  }
                >
                  <CloseIcon height={20} width={20} />
                </Pressable>
              </View>
              <View style={{ alignItems: "center", marginTop: 10 }}>
                <SuspendedIcon />
              </View>
            </View>
            <View style={{ alignItems: "center", marginTop: 25 }}>
              <Text style={{ fontFamily: fontFamily.bold, fontSize: 20 }}>
                {t(`${PATH}/accountSuspended`)}
              </Text>
              <Text style={styles.suspensionMsg}>
                {t(`${PATH}/accountSuspendedMsg`)}
              </Text>
            </View>
            <Button
              borderRadius={6}
              btnText={t(`${PATH}/raiseTicket`)}
              height={40}
              textStyle={styles.buttonTextStyle}
              onPress={onClickRaiseSupportTicket}
              containerStyle={{
                justifyContent: "center",
                alignSelf: "center",
                alignContent: "center",
                marginTop: 25,
              }}
            />
          </View>
        </Animatable.View>
      </Modal>
    );
  }
  return null;
}

export default SuspensionHOC(SuspensionModal);

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: metrics.screenWidth,
    padding: metrics.margin2,
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  modalView: {
    width: "100%",
    backgroundColor: "white",
    paddingHorizontal: 16,
    maxHeight: 330,
    height: 320,
    borderRadius: 10,
    shadowColor: "rgba(0, 0, 0, 0.2)",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  buttonTextStyle: {
    fontFamily: "NotoSansDevanagari-SemiBold",
  },
  suspensionMsg: {
    textAlign: "center",
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 12,
    marginTop: 8,
  },
});
